export default {
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40 // also NUM_SOUTH
};


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-tabs/src/KeyCode.js
// module id = 881
// module chunks = 0